module.exports = __webpack_public_path__ + "static/media/pinterest.e90cc3e6.svg";